import MetricSection from './MetricSection'

export default MetricSection
